<label class="title">{{listName}}</label>
<div class="list">
    <ng-container *ngFor="let video of playlist">
        <app-video-card [videoToPlay]="video" (click)="playVideo(video)"></app-video-card>
    </ng-container>
</div>